import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { useState, useRef, useEffect } from "react";
import BryxButton from "../BryxButton";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxSmartSearchBar from "./BryxSmartSearchBar";
const BryxCollapsibleSmartSearchBar = styled((props) => {
    const [expanded, setExpanded] = useState(false);
    const [shouldFocus, setShouldFocus] = useState(false);
    const inputRef = useRef(null); // ref for forcing a focus on the input when button is clicked
    function escListener(e) {
        if (e.key != "Escape")
            return;
        inputRef.current?.blur();
    }
    function handleExpandTrigger() {
        setExpanded(true);
        setShouldFocus(true);
        props.hookGrow?.();
        // bind <esc>
        document.addEventListener("keydown", escListener);
    }
    function afterClear() {
        inputRef.current?.focus();
        props.hookClear?.();
    }
    useEffect(() => {
        if (!inputRef.current)
            throw "underlying input did not mount in time!";
        inputRef.current.onblur = () => {
            if (!!inputRef.current?.value)
                return;
            setExpanded(false);
            props.hookShrink?.();
            // unbind <esc>
            document.removeEventListener("keydown", escListener);
        };
    }, []);
    return (_jsxs("div", { className: props.className + " " + (!!expanded ? "active" : ""), children: [_jsx(BryxButton, { variant: "outlined", onClick: handleExpandTrigger, style: { visibility: !expanded || shouldFocus ? "visible" : "hidden" }, onTransitionEnd: () => {
                    if (!shouldFocus)
                        return;
                    inputRef.current?.focus();
                    setShouldFocus(false);
                }, children: _jsx(BryxIcon, { iconName: "search", smIconSize: true }) }), _jsx(BryxSmartSearchBar, { inputRef: inputRef, placeholder: props.placeholder ?? "Search...", hookClear: afterClear, hookChange: props.hookChange })] }));
})(({ theme }) => {
    return {
        "&": {
            position: "relative",
            width: "34px",
            height: "34px",
            margin: "0px",
            "& input[type=text]::placeholder": {
                opacity: 1,
            },
            "&, & *": {
                transition: `
                    width 250ms,
                    opacity 250ms,
                    z-index 0ms 250ms,
                    padding 250ms
                `,
            },
            "& > button": {
                position: "absolute",
                width: "100%",
                height: "100%",
                padding: "0px",
                opacity: 1,
                zIndex: 1,
                minWidth: "0px",
                transition: `
                    background-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    width 250ms,
                    opacity 250ms,
                    z-index 0ms 250ms,
                    padding 250ms
                `,
                justifyContent: "start",
                paddingLeft: "8px",
            },
            "& div": {
                position: "absolute",
                zIndex: 0,
                opacity: 0,
                backgroundColor: "unset",
            },
            "&:not(.active) div": {
                width: "32px !important",
            },
            "&.active": {
                width: "243px",
                "& > button": {
                    opacity: 0,
                    zIndex: 0,
                    // keep icon in place
                    justifyContent: "left",
                    paddingLeft: "16px",
                },
                "& div": {
                    opacity: 1,
                    zIndex: 1,
                },
            },
        },
    };
});
export default BryxCollapsibleSmartSearchBar;
